// Small date helpers for the sales pipeline's follow-ups and activity times. Follow-ups are set for the working morning, in the
// browser's own time zone (the person doing the selling is the one reading them).

export const DAY_MS = 24 * 60 * 60 * 1000;

/** A follow-up `days` days from `from` at ten in the morning, as an ISO instant. */
export function followUpIn(days: number, from: number): string {
  const date = new Date(from);
  date.setDate(date.getDate() + days);
  date.setHours(10, 0, 0, 0);
  return date.toISOString();
}

/** The midnight that began the day of `instant`, in the browser's time zone, in epoch milliseconds. */
export function startOfLocalDay(instant: number): number {
  const date = new Date(instant);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

const two = (value: number) => String(value).padStart(2, '0');

/** An instant as a `datetime-local` input writes it: `2026-10-14T09:30`, in the browser's time zone. */
export function toLocalInput(instant: number | string): string {
  const date = new Date(instant);
  return `${date.getFullYear()}-${two(date.getMonth() + 1)}-${two(date.getDate())}T${two(date.getHours())}:${two(date.getMinutes())}`;
}

/** A `datetime-local` value as an ISO instant, or `undefined` when it is not a date. */
export function fromLocalInput(value: string): string | undefined {
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? undefined : new Date(time).toISOString();
}
